import thumbnail1 from "../../Assets/img/VideoThumbnails/thumnail-1.jpg";
import thumbnail2 from "../../Assets/img/VideoThumbnails/thumnail-2.jpg";
import thumbnail3 from "../../Assets/img/VideoThumbnails/thumnail-3.jpg";
import thumbnail4 from "../../Assets/img/VideoThumbnails/thumnail-4.jpg";
import thumbnail5 from "../../Assets/img/VideoThumbnails/thumbnail-5.jpg";
import thumbnail6 from "../../Assets/img/VideoThumbnails/thumbnail-6.jpg";
import thumbnail7 from "../../Assets/img/VideoThumbnails/thumbnail-7.jpg";
import thumbnail8 from "../../Assets/img/VideoThumbnails/thumbnail-8.jpg";
import thumbnail9 from "../../Assets/img/VideoThumbnails/thumbnail-10.jpg";
import thumbnail10 from "../../Assets/img/VideoThumbnails/thumbnail-11.jpg";
import thumbnail11 from "../../Assets/img/VideoThumbnails/thumbnail-12.jpg";
import thumbnail12 from "../../Assets/img/VideoThumbnails/thumbnail-13.jpg";
import thumbnail13 from "../../Assets/img/VideoThumbnails/thumbnail-14.jpg";
import thumbnail14 from "../../Assets/img/VideoThumbnails/thumbnail-14.jpg";

let video = [
  {
    videoUrl: "https://www.youtube.com/embed/VYNTBWBqncU",
    category: "Audit & Assurance",
    thumbnail: thumbnail1,
    description: "Accounting Basics Explained Through a Story  - Leila Gharani",
    date: "Nov 12 2019",
  },
  {
    videoUrl: "https://www.youtube.com/embed/mKFt6awynfc",
    category: "Audit & Assurance",
    thumbnail: thumbnail2,
    description:
      "KPMG Climate Accounting Infrastructure for Real Estate  - John Calcom",
    date: "Feb 01 2021",
  },
  {
    videoUrl: "https://www.youtube.com/embed/9xqAKhAn_hU",
    category: "Audit & Assurance",
    thumbnail: thumbnail3,
    description: "Why Advisory?  - Andrew Ellis",
    date: "Sep 13 2017",
  },
  {
    videoUrl: "https://www.youtube.com/embed/bpa8p8yNaO4",
    category: "Audit & Assurance",
    thumbnail: thumbnail4,
    description:
      "KPMG Master of Accounting with Data and Analytics Program  - Amy Devoe",
    date: "Apr 05 2019",
  },
  {
    videoUrl: "https://www.youtube.com/embed/dCHjedDxHE0",
    category: "Audit & Assurance",
    thumbnail: thumbnail5,
    description: "Kpmg Global Accounting  - Jacob Dheore",
    date: "May 09 2019",
  },
  {
    videoUrl: "https://www.youtube.com/embed/0PbjZ01ObLA",
    category: "Audit & Assurance",
    thumbnail: thumbnail6,
    description: "Best Advice to Small Business Owners  - Warren Buffett",
    date: "Jun 11 2016",
  },
  {
    videoUrl: "https://www.youtube.com/embed/aSZrg3f8Jig",
    category: "Audit & Assurance",
    thumbnail: thumbnail7,
    description: "MS Accounting'19 Deloitte - Yousun Lee",
    date: "May 09 2019",
  },
  {
    videoUrl: "https://www.youtube.com/embed/LTkHq3cNN8I",
    category: "Audit & Assurance",
    thumbnail: thumbnail8,
    description:
      "The Impact of a carrer in Accounting & Internal Controls  - Jarrai",
    date: "Apr 09 2021",
  },
  // {
  //   videoUrl: "https://www.youtube.com/embed/pkdldN2f9u4",
  //   category: "Audit & Assurance",
  //   thumbnail: thumbnail9,
  //   description: "The Future of Accounting  - Stefert Lorel",
  //   date: "Feb 26 2018",
  // },
  // {
  //   videoUrl: "https://www.youtube.com/embed/nb1Yq9b1ygU",
  //   category: "Audit & Assurance",
  //   thumbnail: thumbnail10,
  //   description:
  //     "Gateway to Consultancy with CIMA and Deloitte  - Sarah Barlow",
  //   date: "Sep 18 2018",
  // },
  // {
  //   videoUrl: "https://www.youtube.com/embed/VuAgxZ6OpWw",
  //   category: "Audit & Assurance",
  //   thumbnail: thumbnail11,
  //   description: "Learn About the Accounting profession - Audris Melainne",
  //   date: "Mar 13 2013",
  // },
  // {
  //   videoUrl: "https://www.youtube.com/embed/lWS6J6-Vmiw",
  //   category: "Audit & Assurance",
  //   thumbnail: thumbnail12,
  //   description: "Assurance Associate is being Like - Roger Redrigues",
  //   date: "May 09 2019",
  // },
  // {
  //   videoUrl: "https://www.youtube.com/embed/wGnh37t79Vc",
  //   category: "Audit & Assurance",
  //   thumbnail: thumbnail14,
  //   description: "Tax Reform readiness - Rick Levin",
  //   date: "Oct 05 2018",
  // },

  {
    videoUrl: "https://www.youtube.com/embed/VYNTBWBqncU",
    category: "Document & Report",
    thumbnail: thumbnail13,
    description: "Advisory Necessary or not for Accounting  - Moenn Tinok",
    date: "May 09 2019",
  },

  {
    videoUrl: "https://www.youtube.com/embed/iWxPt2M0Kbg",
    category: "Compliance & Due Diligence",
    thumbnail: thumbnail13,
    description:
      "Gateway to Consultancy with CIMA and Deloitte  - Robert Lemen",
    date: "May 09 2019",
  },
  {
    videoUrl: "https://www.youtube.com/embed/zWjPT94lV_8",
    category: "Compliance & Due Diligence",
    thumbnail: thumbnail2,
    description: "Tax Reform readiness  - Rick Levin",
    date: "Oct 05 2018",
  },
  {
    videoUrl: "https://www.youtube.com/embed/Jpzri72Zak",
    category: "Compliance & Due Diligence",
    thumbnail: thumbnail3,
    description: "Accounting Basics Explained Through a Story  - Leila Gharani",
    date: "Nov 12 2019",
  },
];

export default video;
